var map = {
	"./033-bm.webp": 1242,
	"./033-cn.webp": 1243,
	"./033.webp": 1244,
	"./13-bm.webp": 1245,
	"./13-cn.webp": 1246,
	"./13.webp": 1247,
	"./3-bm.webp": 1248,
	"./3-cn.webp": 1249,
	"./3.webp": 1250,
	"./angpao-bg-mobile.webp": 1251,
	"./angpao-bg.webp": 1252,
	"./angpao-bm.webp": 1253,
	"./angpao-cn.webp": 1254,
	"./angpao.webp": 1255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;